module.exports = __webpack_public_path__ + "img/1.1abc7381.png";